import { Box, Divider, Flex, Link, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ContractDataFieldNameDto, ProcedureType } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { ContractState } from "../../../../common/redux/reducers/contractReducer";
import { noCompetitionProvision } from "../../../sourcing-events/buyer/wizard/utils/noCompetition";
import { urls } from "../../../../urls";
import { requireDataFields } from "../../typeguards";

interface Props {
  data: ContractState["contract"];
}

const originSourcingEventUrl = (sourcingEvent: { id: string }, viewerIsOwner: boolean): string =>
  viewerIsOwner ? urls.app.sourcingEvents.view.go(sourcingEvent.id) : urls.app.supplier.procurement.go(sourcingEvent.id);

export const OriginSourcingEvent = ({ data }: Props) => {
  const { t } = useTranslation();
  const { selectedOrg } = useLoggedInWithOrgContextState();
  const dataFields = requireDataFields(data);
  const sourcingEvent = dataFields.originSourcingEvent;
  const addedDataFields = dataFields.addedDataFields.map((e) => e.name);
  const viewerIsOwner = data.owningOrganizationId === selectedOrg.id;

  if (addedDataFields.includes(ContractDataFieldNameDto.OriginSourcingEvent) && !sourcingEvent) {
    return (
      <Box padding="15px" paddingBottom={"20px"} w="100%">
        <Text fontWeight={"bold"} fontSize="sm" color="#808B9B">
          {t("Origin sourcing event")}
        </Text>
        <Divider marginTop={"5px"} marginBottom={"5px"} />
        <Text fontStyle={"italic"}>{t("Not provided")}</Text>
      </Box>
    );
  }

  if (!sourcingEvent) {
    return null;
  }

  return (
    <Box padding="15px" paddingBottom={"20px"} w="100%">
      <Text fontWeight={"bold"} fontSize="sm" color="#808B9B">
        {t("Origin sourcing event")}
      </Text>
      <Divider marginTop={"5px"} marginBottom={"5px"} />
      <Flex mt="7px" key={sourcingEvent.id}>
        <Link href={originSourcingEventUrl(sourcingEvent, viewerIsOwner)} color="blue.500" target="_blank">
          {sourcingEvent.title}
        </Link>
      </Flex>
      {sourcingEvent.type === "SourcingEventV2" && sourcingEvent.noCompetitionCondition && (
        <Text fontSize="sm" color="smMuted" mt="1">
          {t(ProcedureType.WithoutCompetition)},{" "}
          {noCompetitionProvision(
            sourcingEvent.noCompetitionCondition,
            sourcingEvent.regulation,
            t,
            sourcingEvent.followsDesignContestBelowEeaTier,
          )}
        </Text>
      )}
    </Box>
  );
};
